import React from 'react'
import { Icon, Tooltip, Box } from '@allied-solutions/affinity'
import { InfoSolid } from '@allied-solutions/affinity-react-icons/dist/standard'

const Hint = ({ content, ...props }) => (
  <Tooltip {...props} content={content} zIndex={10000}>
    <Box 
      display="inline-flex" 
      alignItems="center"
      role="tooltip"
      aria-label={content ? `More information: ${content}` : 'More information'}
      tabIndex={0}
    >
      <Icon size='sm' src={InfoSolid} color="brand" />
    </Box>
  </Tooltip>
)

export { Hint }
